import React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { LogoutOutlined } from '@ant-design/icons';
import { Menu, Select } from 'antd';

import '../App.css';
import stringres from '../translations/stringres';

export default function MenuMain({ currentMenu }) {
    const navigate = useNavigate();

    const logOutClick = () => {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('data');

        navigate('/login');
    };

    const [current, setCurrent] = useState(currentMenu);
    const onClick = (e) => {
        setCurrent(e.key);

        if (e.key === 'logout') logOutClick();
        else navigate('/' + e.key);
    };

    const onSelectChange = (e) => {
        localStorage.setItem('codLingua', e);

        window.location.reload();
    };

    const items = [
        { key: 'clienti', label: stringres.t('clientiProspect'), style: { marginRight: '10px' } },
        { key: 'opportunita', label: stringres.t('opportunitaAttivita'), style: { marginRight: '10px' } },
        { key: 'viaggi', label: stringres.t('viaggi'), style: { marginRight: '10px' } },
        { key: 'divider', disabled: 'true', label: '|' },
        {
            key: 'language',
            label: (
                <div onClick={(e) => e.stopPropagation()}>
                    <Select
                        popupMatchSelectWidth={false}
                        defaultValue={localStorage.getItem('codLingua') ? localStorage.getItem('codLingua') : 'it'}
                        style={{ width: '100px' }}
                        onSelect={onSelectChange}
                    >
                        <Select.Option value="en">English</Select.Option>
                        <Select.Option value="it">Italiano</Select.Option>
                        <Select.Option value="fr">Français</Select.Option>
                    </Select>
                </div>
            ),
        },
        { key: 'logout', label: ' ' + stringres.t('logout'), icon: <LogoutOutlined />, style: { marginLeft: 'auto' } },
    ];

    return <Menu items={items} className="App-MainMenu" mode="horizontal" onClick={onClick} selectedKeys={current} />;
}
